"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    statement: finley_types_1.FinStatementV2.StatementSchema,
    reportFrequency: finley_types_1.FinStatementV2.ReportFrequencySchema,
    currency: finley_types_1.Bank.CurrencyCodeSchema.optional().describe('Defaults to USD'),
    basis: finley_types_1.FinStatementV2.StatementBasisSchema.optional().describe('Defaults to actual'),
    multiplier: zod_1.z.number().optional().describe('Defaults to 1'),
    csvArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('csv containing the financial statement information'),
    rawArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('raw source file').optional(),
    markupArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('highlighted pdf file, generated during an ai2Csv transform').optional(),
});
exports.nodeType = 'file_finStatement';
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
});
exports.artifactType = 'finStatement';
//# sourceMappingURL=types.js.map